import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { dropdownValuesService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseGetAgentListMutationProps = {
	agentId: string;
};

const useGetAgentListMutation = ({ agentId }: UseGetAgentListMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		async ({
			search,
			prevOptions,
			page,
		}: {
			search: string;
			prevOptions: { [key: string]: any };
			page: number;
		}): Promise<{ [key: string]: any }> => {
			const agents = await dropdownValuesService.getSplitProfileAgents(
				agentId,
				search,
				page,
				true,
			);

			const hasMore =
				prevOptions.length + agents.items.length < agents.count;

			return {
				options: agents.items.map(agent => ({
					id: agent.id,
					firstName: agent.first_name,
					lastName: agent.last_name,
					name: `${agent.name} ${
						agent.is_active ? "" : "(inactive)"
					}`,
					entityType: agent.entity_type,
					partnerType: agent.partner_type,
				})),
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGetAgentListMutation;
